import * as React from 'react';

import SpinnerView from './spinner-view';

import pushState from '../push-state';

import { mergeStyleSets, CommandBar, FocusZone, FocusZoneDirection, List, Link, getFocusStyle, getTheme, Icon, getRTL } from '@fluentui/react';

export default class ClassroomSelector extends React.Component {
  constructor() {
    super();
    var theme = getTheme();
    this._styles = mergeStyleSets({
      schoolInfo: {
        margin: 0,
        padding: 0,
        width: 'calc(100% - 10px)',
        paddingLeft: 10
      },
      outer: {
        margin: 0,
        padding: 0,
        width: '100%',
      },
      cellOuter: [
        getFocusStyle(theme, { inset: -1 }),
        {
          minHeight: 54,
          padding: 10,
          boxSizing: 'border-box',
          borderBottom: `1px solid ${theme.semanticColors.bodyDivider}`,
          display: 'flex',
          selectors: {
            '&:hover': { background: theme.palette.neutralLight },
          },
          cursor: 'pointer'
        },
      ],
      cellInner: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
      },
      name: [
        theme.fonts.xLarge,
        {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      ],
      chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: theme.palette.neutralTertiary,
        fontSize: theme.fonts.large.fontSize,
        flexShrink: 0,
      },
      schoolName: [
        theme.fonts.large,
        {
          fontWeight: 'bold'
        }
      ],
      promoter: [
        theme.fonts.small,
        {
          color: theme.palette.neutralTertiary,
          marginBottom: 10,
        }
      ]
    });
  }

	render() {
    if (this.props.sector.classrooms.length === 1) {
      pushState('/classrooms/' + encodeURIComponent(this.props.sector.classrooms[0].id));
      return (<SpinnerView />);
    }
    var commandBarItems = [
      {
        key: 'searchISBN',
        text: 'Cerca per ISBN',
        iconProps: { iconName: 'Search' },
        href: '/books',
        onClick: pushState.menuHandler
      }
    ];
    if (this.props.schools.length > 1) {
      commandBarItems.push({
        key: 'switchSchool',
        text: 'Cambia istituto',
        iconProps: { iconName: 'EMI' },
        href: '/',
        onClick: pushState.menuHandler
      });
    }
    if (this.props.school.sectors.length > 1) {
      commandBarItems.push({
        key: 'switchSector',
        text: 'Cambia indirizzo',
        iconProps: { iconName: 'WorkforceManagement' },
        href: '/schools/' + encodeURIComponent(this.props.school.id),
        onClick: pushState.menuHandler
      });
    }
		return (
      <React.Fragment>
        <CommandBar
          items={commandBarItems}
          ariaLabel="Usa le frecce sinistra e destra per navigare tra i comandi"
        />
        <div className={this._styles.schoolInfo}>
          <span className={this._styles.schoolName}>{this.props.school.name} - {this.props.sector.name}</span><br />
          <span className={this._styles.promoter}>Promotore: <Link href={this.props.school.promoter.url} target="_blank">{this.props.school.promoter.name}</Link></span>
        </div>
        <FocusZone direction={FocusZoneDirection.vertical} className={this._styles.focusZone}>
          <List items={this.props.sector.classrooms} onRenderCell={(classroom) => {
            return (
              <div className={this._styles.cellOuter} data-is-focusable={true} onClick={() => {
                pushState('/classrooms/' + encodeURIComponent(classroom.id));
              }}>
                <div className={this._styles.cellInner}>
                  <div className={this._styles.name}>{classroom.name}</div>
                </div>
                <Icon className={this._styles.chevron} iconName={getRTL() ? 'ChevronLeft' : 'ChevronRight'} />
              </div>
            );
          }} />
        </FocusZone>
      </React.Fragment>
		);
	}
}
